import { render, staticRenderFns } from "./AdminUsersPanel.vue?vue&type=template&id=35a159c1&scoped=true&"
import script from "./AdminUsersPanel.vue?vue&type=script&lang=ts&"
export * from "./AdminUsersPanel.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUsersPanel.vue?vue&type=style&index=0&id=35a159c1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a159c1",
  null
  
)

export default component.exports